


































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  @Prop() projectId!: number;

  dispatchType = "projects/logs";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "时间", dataIndex: "created_time" },
    { title: "操作人", dataIndex: "username" },
    { title: "步骤", scopedSlots: { customRender: "step" } },
    { title: "状态", dataIndex: "status" },
    { title: "备注", scopedSlots: { customRender: "content" } }
  ];

  mounted() {
    this.loadData({
      project_id: this.projectId
    });
  }
}
